export default {
  homeTab: 'home',
  mapTools: []
}
